// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3gSMs","col":"styles_col__10oQI","fulfillmentStatus":"styles_fulfillmentStatus__3W-2L","emailCol":"styles_emailCol__3n987"};